// 全局配置api
// const api = 'http://city.qianyiwangluo.com/index/'
const api = 'http://www.henaniei.org.cn/index/'
export default api



// WEBPACK FOOTER //
// ./src/api.js